// extracted by mini-css-extract-plugin
export default {"largeTickWrapper":"LargeTick-module--large-tick-wrapper--ddb45"};